import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2 } from "lucide-react";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background" role="status" aria-live="polite" aria-label="Checking your session">
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
      </div>
    );
  }

  if (!session) {
    const next = location.pathname + location.search + location.hash;
    const loginUrl = "/login?next=" + encodeURIComponent(next);
    return <Navigate to={loginUrl} replace state={{ returnTo: next }} />;
  }

  return <>{children}</>;
}
